import { LineSvgProps, ResponsiveLine } from "@nivo/line";
import varExport from "../../../styles/var-export.module.scss";
import { DatumValue } from "@nivo/core";

const { darkGreen } = varExport;

interface AverageSapChartProps extends LineSvgProps {}

const isNumeric = (testValue: DatumValue | null | undefined) => {
	return testValue != null && !isNaN(Number(testValue));
};

export default function AverageSapChart({ data }: AverageSapChartProps) {
	// find min and max sap scores
	const minMaxSap = data[0].data.reduce(
		(acc, cur) => {
			acc[0] = isNumeric(cur.y) && Number(cur.y) < acc[0] ? Number(cur.y) : acc[0];
			acc[1] = isNumeric(cur.y) && Number(cur.y) > acc[1] ? Number(cur.y) : acc[1];
			return acc;
		},
		[100, 100]
	);
	const axisRange = [minMaxSap[0] * 0.85, minMaxSap[1] * 1.1];

	return (
		<div className="sap-journey-chart">
			<ResponsiveLine
				margin={{ top: 50, right: 130, bottom: 50, left: 130 }}
				data={data}
				yScale={{ type: "linear", min: axisRange[0], max: axisRange[1] }}
				axisLeft={{
					legend: "Your Average SAP",
					legendPosition: "middle",
					legendOffset: -90,
					tickValues: 6,
					tickPadding: 40,
					tickSize: 0,
				}}
				axisBottom={null}
				layers={["grid", "axes", "lines", "markers", "legends"]}
				enableGridX={false}
				enableGridY={false}
				curve="monotoneX"
				lineWidth={6}
				colors={[darkGreen]}
				animate={false}
			/>
		</div>
	);
}
